import { SearchHistoryStoreController } from "./SearchHistoryStoreController";

const searchHistoryStoreController = new SearchHistoryStoreController();

export function useSearchHistoryStore() {
  const searchHistory = computed(() => searchHistoryStoreController.searchHistory);
  const lastSearchQuery = computed(() => searchHistoryStoreController.lastSearchQuery);

  function pushSearchHistoryValue(payload: string) {
    searchHistoryStoreController.pushSearchHistoryValue(payload);
  }

  function removeSearchHistoryValue(payload: string) {
    searchHistoryStoreController.removeSearchHistoryValue(payload);
  }

  function clearSearchHistory() {
    searchHistoryStoreController.clearSearchHistory();
  }

  return {
    searchHistory,
    lastSearchQuery,
    pushSearchHistoryValue,
    removeSearchHistoryValue,
    clearSearchHistory,
  };
}